import React, { Component } from 'react';

class InsightsPage extends Component {
  render(){
    return (
      <div className="page insights">
        <h1>Insights page</h1>
      </div>
    )
  }
}

export default InsightsPage;



// WEBPACK FOOTER //
// ./src/components/insights/index.js